<template>
    <component :is="tag" v-bind="{ ...$props, ...$attrs }" ref="button" class="dropdown-item" @click.stop="onClick">
        <slot name="default" />
        <Confirmation v-if="loaded && message" :message="props.message" :target="button" :value="item" @confirm="onConfirm" />
    </component>
</template>

<script lang="ts" setup>
export interface Props
{
    message?: string;
    tag?: string;
}

defineOptions({
    name: 'ListViewButton',
    inheritAttrs: false
});

const props = withDefaults(defineProps<Props>(), {
    message: null,
    tag: 'button'
});

const button = ref<any>(null);
const item = inject<ComputedRef<any>>('item');
const dropdownRef = inject<any>('dropdownRef');
const loaded = ref(false);
const emit = defineEmits<{
    (e: 'confirm', item: any): void;
}>();

onMounted(() =>
{
    loaded.value = true;
});

const onConfirm = (item: any): any =>
{
    emit('confirm', item);
};

const onClick = (): void =>
{
    if (!props.message)
        dropdownRef.value.hide();
};
</script>
